import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=72f697af&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72f697af')) {
      api.createRecord('72f697af', component.options)
    } else {
      api.reload('72f697af', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=72f697af&", function () {
      api.rerender('72f697af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2I2Dc2I9z5pZB/JS/videoIframe.vue"
export default component.exports